import axios from "axios";
import Qs from "qs";
import app from '../main';
import router from "@/router";

let loading = null;

const Axios = axios.create({
    timeout: 100000,
    responseType: "json",
    withCredentials: true,
    headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
        Platform: "web",
        pf: 1
    },
});

Axios.interceptors.request.use(
    config => {
        // loading = app && app.$loading({
        //     lock: false,
        //     spinner: "icon-loading",
        //     background: "rgba(0, 0, 0, 0)"
        // });
        if ((config.params && config.params.isShow_loading) || config.url.split('?')[0] == "/api/operations/show" || config.url.split('?')[0] == "/api/bytedance/order/query") {
            loading && loading.close();
            loading = null;
        } else {
            loading = app && app.$loading({
                lock: false,
                spinner: "icon-loading",
                background: "rgba(0, 0, 0, 0)"
            });
        }
        if (localStorage.getItem("auth_token")) {
            config.headers.Authorization = `Bearer ${localStorage.getItem(
                "auth_token"
            )}`;
        }
        if (
            config.method === "post" &&
            config.headers["Content-Type"] !== "multipart/form-data" &&
            config.headers["Content-Type"] != "application/json"
        ) {
            config.data = Qs.stringify(config.data);
        }
        let lan = location.hash;
        if (!lan && localStorage.getItem('language')) {
            lan = localStorage.getItem('language');
        }
        const language = lan === "#!en" ? "en_us" : "zh_cn";
        config.headers["Language"] = language;
        return config;
    },
    error => {
        loading && loading.close();
        return Promise.reject(error);
    }
);


Axios.interceptors.response.use(
    response => {
        // $t('global.关闭') loading $t('global.效果')
        loading && loading.close();
        if (response && response.data && response.data.code !== "OK") {

            if (response.data.code == "Unauthorized") {
                if (!window.location.href.includes('?redirecturl=')) {
                    router.push(`/login?redirecturl=${window.location.href}`);
                }

                localStorage.removeItem('auth_token');
                app.$store.state.peopleMessage = null;
                localStorage.removeItem('isLogin');
                app.$store.state.isLogin = false;
                return response.data;

            } else if (response.data.code == 400 || response.data.code == 401) {
                app.$message({
                    showClose: true,
                    message: response.data.message,
                    type: "error",
                    duration: 2000
                });
                return response.data;
            } else if (response.data.code == 'Warning') {
                app.$message({
                    showClose: true,
                    message: response.data.message,
                    type: "warning",
                    duration: 2000
                });
                return response.data;
            } else if (response.data.format != null && response.data.streams != null) {
                return response.data;
            } else {
                if (response.data.message) {
                    app.$message({
                        showClose: true,
                        message: response.data.message,
                        type: "error",
                        duration: 2000
                    })
                }
            }
            return Promise.resolve(response.data);
        } else {
            return response && response.data;
        }
    },
    error => {
        if (JSON.parse(JSON.stringify(error)).config.timeout) {
            // app.$message({
            //     showClose: true,
            //     message: "Error! Please check your internet connection!",
            //     type: "error",
            //     duration: 2000
            // })
            loading && loading.close();
            return
        }
        loading && loading.close();
        return Promise.reject(error);
    }
);


export default Axios;


// WEBPACK FOOTER //
// ./src/util/axios.js